import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { GrainOverlay } from "./components/effects/GrainOverlay";
import { CustomCursor } from "./components/effects/CustomCursor";
import { Nav, MobileCTA } from "./components/Nav";
import { Hero } from "./components/sections/Hero";
import { Ticker } from "./components/sections/Ticker";
import { Manifesto } from "./components/sections/Manifesto";
import { Letter } from "./components/sections/Letter";
import { Audience } from "./components/sections/Audience";
import { Roadmap } from "./components/sections/Roadmap";
import { Curriculum } from "./components/sections/Curriculum";
import { HostSection } from "./components/sections/HostSection";
import { Transformation } from "./components/sections/Transformation";
import { Takeaways } from "./components/sections/Takeaways";
import { Faq } from "./components/sections/Faq";
import { FinalCTA } from "./components/sections/FinalCTA";
import { Footer } from "./components/sections/Footer";
import { useAttribution } from "./hooks/useAttribution";
import ThankYou from "./pages/ThankYou";
import Replay from "./pages/Replay";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";

gsap.registerPlugin(ScrollTrigger);

function Landing() {
  const attribution = useAttribution();

  return (
    <div className="reg-app min-h-screen relative isolate" data-testid="landing-page">
      <GrainOverlay />
      <CustomCursor />
      <Nav />
      <main>
        <Hero attribution={attribution} />
        <Ticker />
        <Manifesto />
        <Letter />
        <Audience />
        <Roadmap />
        <Curriculum />
        <HostSection />
        <Transformation />
        <Takeaways />
        <Faq />
        <FinalCTA attribution={attribution} />
        <Footer />
      </main>
      <MobileCTA />
    </div>
  );
}

function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
    lenis.on("scroll", ScrollTrigger.update);
    const tick = (time) => lenis.raf(time * 1000);
    gsap.ticker.add(tick);
    gsap.ticker.lagSmoothing(0);
    return () => {
      gsap.ticker.remove(tick);
      lenis.destroy();
    };
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/thank-you" element={<ThankYou />} />
        <Route path="/replay" element={<Replay />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
